export function mixinStyles(origin: Record<string, string>, mixin: Record<string, string>): void {
  for (const [k, v] of Object.entries(origin)) {
    if (k in mixin) {
      mixin[k] = `${v} ${mixin[k]}`
    } else {
      mixin[k] = v
    }
  }
}
